// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7caf3e0","809":"2ccab9ef"}[chunkId] + ".chunk.js";
};